var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
const request = (options) => __awaiter(void 0, void 0, void 0, function* () {
    const { url, headers = {}, method } = options;
    let { payload } = options;
    headers.Authorization = `Bearer ${options.authToken}`;
    if (headers["Content-Type"] == null) {
        headers["Content-Type"] = "application/json";
        payload = JSON.stringify(payload);
    }
    return axios({ method, url, headers, data: payload })
        .then((res) => res.data)
        .catch((err) => {
        var _a, _b;
        if (((_b = (_a = err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error) != null) {
            throw err.response.data.error;
        }
        throw err;
    });
});
const detectBrowser = () => {
    let sBrowser;
    const sUsrAg = navigator.userAgent;
    if (sUsrAg.indexOf("Firefox") > -1)
        sBrowser = "firefox";
    else if (sUsrAg.indexOf("SamsungBrowser") > -1)
        sBrowser = "samsung-internet";
    else if (sUsrAg.indexOf("Opera") > -1 || sUsrAg.indexOf("OPR") > -1)
        sBrowser = "opera";
    else if (sUsrAg.indexOf("Trident") > -1)
        sBrowser = "ie";
    else if (sUsrAg.indexOf("Edge") > -1)
        sBrowser = "edge";
    else if (sUsrAg.indexOf("Chrome") > -1)
        sBrowser = "chrome";
    else if (sUsrAg.indexOf("Safari") > -1)
        sBrowser = "safari";
    else
        sBrowser = "unknown";
    return sBrowser;
};
const isAccessedFromMobileApp = () => {
    const mobileAppWebview = window.flutter_inappwebview;
    return mobileAppWebview != null;
};
export default { request, detectBrowser, isAccessedFromMobileApp };
export function generateUUID() {
    let uuid = "";
    const randomValues = window.crypto.getRandomValues(new Uint8Array(16));
    for (let i = 0; i < randomValues.length; i += 1) {
        const hexDigit = randomValues[i].toString(16);
        uuid += hexDigit.length === 1 ? `0${hexDigit}` : hexDigit;
    }
    uuid = `${uuid.substring(0, 12)}4${uuid.substring(13, 16)}a${uuid.substring(17)}`;
    return uuid;
}
export function getBrowserData() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const ua = navigator.userAgent;
    const name = detectBrowser();
    let version = "Unknown";
    if (/Chrome/.test(ua)) {
        version = (_b = (_a = ua.match(/Chrome\/(\d+\.\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : version;
    }
    else if (/Firefox/.test(ua)) {
        version = (_d = (_c = ua.match(/Firefox\/(\d+\.\d+)/)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : version;
    }
    else if (/Safari/.test(ua)) {
        version = (_f = (_e = ua.match(/Version\/(\d+\.\d+)/)) === null || _e === void 0 ? void 0 : _e[1]) !== null && _f !== void 0 ? _f : version;
    }
    else if (/Edge/.test(ua)) {
        version = (_h = (_g = ua.match(/Edge\/(\d+\.\d+)/)) === null || _g === void 0 ? void 0 : _g[1]) !== null && _h !== void 0 ? _h : version;
    }
    else if (/Trident/.test(ua)) {
        version = (_k = (_j = ua.match(/rv:(\d+\.\d+)/)) === null || _j === void 0 ? void 0 : _j[1]) !== null && _k !== void 0 ? _k : version;
    }
    return { name, version };
}
export function getOSName() {
    const ua = navigator.userAgent;
    const { platform } = navigator;
    let os = "Unknown";
    if (platform.indexOf("Win") !== -1) {
        os = "Windows";
    }
    else if (platform.indexOf("Mac") !== -1) {
        os = "macOS";
    }
    else if (ua.indexOf("Android") !== -1) {
        os = "Android";
    }
    else if (ua.indexOf("Linux") !== -1) {
        os = "Linux";
    }
    else if (ua.indexOf("iPhone") !== -1) {
        os = "iOS";
    }
    return os;
}
export function getOSVersion() {
    const ua = navigator.userAgent;
    let version = "Unknown";
    if (navigator.appVersion.indexOf("Win") !== -1) {
        version = String(parseFloat(ua.split("Windows NT")[1].split(";")[0]));
    }
    else if (ua.indexOf("Mac") !== -1) {
        [version] = ua.split("Mac OS X")[1].split(")")[0].split("_");
    }
    else if (ua.indexOf("Android") !== -1) {
        [version] = ua.split("Android")[1].split(";");
    }
    else if (ua.indexOf("iPhone") !== -1) {
        [version] = ua.split("iPhone OS")[1].split("_");
    }
    return version;
}
export function isMobileUserAgent() {
    const { userAgent } = navigator;
    const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent);
    return isMobile;
}
export const isIOSBrowser = () => {
    const isModernIpad = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    const isIOS = /iPhone|iPad/i.test(navigator.userAgent) || isModernIpad;
    return isIOS;
};
